module.exports = __webpack_public_path__ + "media/images/common/logo_header-9bf4c793763c9db453e1fbdf619e7fcd.png";